import * as React from "react";
import { withTheme } from "styled-components";

import { withDefault } from "collection-utils";

import { mapUrl, ImageSourceKind, MapTheme } from "common/components/portable-renderers";
import { AutoSizer } from "react-virtualized/dist/es/AutoSizer";
import { Style, MapImg } from "./location-map-style";
import type { MapLocation, AppEnvironment } from "common/components/types";
import type { RuntimeTheme } from "../../../lib/theme/theme";
import { dontAwait } from "common/Support";

interface Props {
    readonly appEnvironment: AppEnvironment;
    readonly location: MapLocation;
    readonly zoom: number | undefined;
    readonly onClick: (() => void) | undefined;
    readonly theme: RuntimeTheme;
}

interface State {
    url: string;
}

class LocationMap extends React.PureComponent<Props, State> {
    public state: State = {
        url: "",
    };

    private async updateUrl(width: number, height: number) {
        const theme = this.props.theme.mapTheme === "light" ? MapTheme.Light : MapTheme.Dark;
        const url = await mapUrl(
            this.props.appEnvironment,
            { kind: ImageSourceKind.GeoCoordinates, location: this.props.location },
            width,
            height,
            withDefault(this.props.zoom, 15),
            theme
        );
        if (url !== undefined && url !== this.state.url) {
            this.setState({ url });
        }
    }

    public render(): React.ReactNode {
        const { onClick } = this.props;

        const map = (
            <AutoSizer>
                {(props: { width: number; height: number }) => {
                    dontAwait(this.updateUrl(props.width, props.height));
                    return <MapImg src={this.state.url} />;
                }}
            </AutoSizer>
        );
        const content = (
            <Style data-test="app-static-map" className="fullBleed">
                {map}
            </Style>
        );
        return onClick === undefined ? (
            content
        ) : (
            <button aria-label="clickable map" onClick={onClick} style={{ cursor: "pointer" }}>
                {content}
            </button>
        );
    }
}

export default withTheme(LocationMap);
